<script>
import { mapState } from "vuex";
import AvatarCropper from "vue-avatar-cropper";

/**
 * "Foto para o Ranking" de Minha Conta. Separada do avatar (widgets/avatar.vue) porque no avatar
 * muita regional usa o brasão — esta é a foto da PESSOA, mostrada em Rankings e Ranking Nacional.
 * API: POST user/ranking-foto (campo "foto"); a foto atual vem em account.user.ranking_foto.
 */
export default {
  components: { AvatarCropper },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    foto() {
      return this.account.user.ranking_foto || null;
    },
  },
  data() {
    return {
      loading: false,
      message: "",
      url: process.env.VUE_APP_URL_API + "user/ranking-foto",
      headers: {
        "x-auth-token": window.localStorage.token,
      },
      options: {
        width: 600,
        height: 600,
      },
      quality: 0.9,
      labels: {
        submit: "Salvar",
        cancel: "Cancelar",
      },
    };
  },
  methods: {
    handleUploading() {
      this.loading = true;
      this.message = "";
    },
    handleCompleted(response) {
      this.loading = false;
      if (response && response.status == "success") {
        this.$set(this.$store.state.account.user, "ranking_foto", response.foto);
        this.message = "";
      } else {
        this.message = (response && response.message) || "Não foi possível enviar a foto. Tente novamente.";
      }
    },
    handlerError() {
      this.loading = false;
      this.message = "Não foi possível enviar a foto. Verifique sua conexão e tente novamente.";
    },
  },
};
</script>

<template>
  <div class="rf-wrap">
    <div class="rf-box">
      <div v-if="loading" class="rf-foto rf-loading">
        <b-spinner variant="secondary" role="status" />
      </div>
      <img v-else-if="foto" :src="foto" class="rf-foto" alt="Sua foto para o Ranking" />
      <div v-else class="rf-foto rf-vazia" aria-hidden="true">
        <i class="bx bx-camera"></i>
      </div>
    </div>

    <div class="rf-texto">
      <h5 class="mb-1">Foto para o Ranking</h5>
      <!-- Comentário/orientação pedida para esta seção. -->
      <p class="rf-comentario mb-2">
        Esta é a foto que aparece para toda a rede nos <strong>Rankings</strong> e no <strong>Ranking Nacional</strong>.
        Envie uma foto <strong>sua</strong>, de rosto, bem iluminada e com fundo neutro —
        <strong>não use o brasão da Regional</strong> (ele continua no seu avatar).
      </p>
      <button id="pick-ranking-foto" type="button" class="btn btn-default btn-sm" :disabled="loading">
        <i class="bx bx-upload align-middle"></i> {{ foto ? "Trocar foto" : "Enviar foto" }}
      </button>
      <div v-if="message" class="text-danger small mt-2" role="alert">{{ message }}</div>
    </div>

    <avatar-cropper
      @uploading="handleUploading"
      @completed="handleCompleted"
      @error="handlerError"
      :upload-url="url"
      :upload-headers="headers"
      upload-form-name="foto"
      :output-options="options"
      :output-quality="quality"
      output-mime="image/jpeg"
      mimes="image/jpeg, image/png, image/webp"
      :labels="labels"
      trigger="#pick-ranking-foto"
    />
  </div>
</template>

<style scoped>
.rf-wrap {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}
.rf-box {
  flex: 0 0 auto;
}
.rf-foto {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rf-vazia,
.rf-loading {
  background: var(--st-canvas, #f1f3f6);
  color: var(--st-text-muted, #74788d);
  font-size: 40px;
}
.rf-texto {
  flex: 1 1 260px;
  min-width: 0;
}
.rf-comentario {
  font-size: 13px;
  color: var(--st-text-muted, #74788d);
  line-height: 1.5;
}
</style>
